import React from "react";
import { Modal, ModalBody, ModalContent, ModalHeader } from "@heroui/react";
import ChatConversation from "@/components/chat/ChatConversation";

// Modal wrapper around ChatConversation — used where a quick chat pops up over
// another page. The cohort Messages page embeds ChatConversation directly.
interface ChatWindowProps {
  isOpen: boolean;
  onClose: () => void;
  cohortId?: string;
  cohortName?: string;
  participantEmail?: string;
  participantName?: string;
  // Shown in the modal header — the person on the other end.
  title: string;
  subtitle?: string;
}

const ChatWindow: React.FC<ChatWindowProps> = ({
  isOpen,
  onClose,
  cohortId,
  cohortName,
  participantEmail,
  participantName,
  title,
  subtitle,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} size="2xl" placement="center">
    <ModalContent>
      <ModalHeader className="flex flex-col gap-0.5">
        <span>{title}</span>
        {subtitle && (
          <span className="text-sm font-normal text-gray-500">{subtitle}</span>
        )}
      </ModalHeader>

      <ModalBody className="p-0">
        <ChatConversation
          cohortId={cohortId}
          cohortName={cohortName}
          participantEmail={participantEmail}
          participantName={participantName}
          active={isOpen}
          className="h-[65vh] min-h-[360px]"
        />
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default ChatWindow;
